import React, { useEffect, useRef } from 'react';
import {
  Wrapper,
  Logo,
  SubscribeBlock,
  SocialLink,
  MixedLink,
} from '../common';
import './Footer.scss';

const Footer = (props) => {
  const {
    settings,
    location,
    viewportTopPos,
  } = props;
  const {
    phone,
    email,
    primaryMenu: footerLinks,
    socialLinks,
    supportingPages,
  } = settings;
  const { pathname: currentPath } = location;
  const isHome = Boolean(currentPath === '/');
  const currentYear = new Date().getFullYear();
  const footerRef = useRef(null);
  useEffect(() => {
    const footerInView = Boolean(viewportTopPos > footerRef.current.offsetTop);
    if (footerInView) document.body.classList.add('invert-header');
    if (!footerInView) document.body.classList.remove('invert-header');
    return () => {
      document.body.classList.remove('invert-header');
    };
  }, [viewportTopPos]);
  return (
    <footer className="footer" ref={footerRef}>
      <div className="top-curve">
        <svg viewBox="0 0 1600 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path
            d="M0 0c133.333 20 266.667 30 400 30C600 30 600 0 800 0s198.814 30 398.814 30C1332.147 30 1465.876 20 1600 0v52H0V0z"
            fill="#2A2E24"
            fillRule="evenodd"
          />
        </svg>
      </div>
      <div className="container">
        <Wrapper isBound>
          <div className="footer-section top-section">
            <Logo />
          </div>
          <div className="footer-section middle-section">
            <div className="cols">
              <div className="col col-links">
                <span className="col-title">Index</span>
                { footerLinks && footerLinks.length > 0 && (
                  <ul className="links">
                    {footerLinks.map((link, index) => (
                      <li key={index}>
                        <MixedLink
                          buttonLabel={link.title}
                          buttonLink={link.pageLink}
                          className="link"
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="col col-socials">
                <span className="col-title">Follow</span>
                { socialLinks && socialLinks.length > 0 && (
                  <ul className="social-links">
                    {socialLinks.map(item => (
                      <li key={item.type}>
                        <SocialLink socialLink={item} />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="col col-contact">
                <span className="col-title">Call us</span>
                <a
                  className="telephone"
                  href={`tel:${phone.text}`}
                >
                  {phone.text}
                </a>
                <span className="col-title">Email us</span>
                <a
                  className="email"
                  href={`mailto:${email.text}`}
                >
                  {email.text}
                </a>
              </div>
              <div className="col col-subscribe">
                <span className="col-title">Stay tuned</span>
                <SubscribeBlock />
              </div>
            </div>
          </div>
          <div className="footer-section bottom-section">
            <div className="cols">
              <div className="col col-legal-links">
                { supportingPages && supportingPages.length > 0 && (
                  <ul className="links">
                    {supportingPages.map((link, index) => (
                      <li key={index}>
                        <MixedLink
                          buttonLabel={link.title}
                          buttonLink={link.pageLink}
                          className="link"
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="col col-signature">
              </div>
              <div className="col col-copyright">
                <span>{`Copyright ${currentYear}`}</span>
              </div>
            </div>
          </div>
        </Wrapper>
      </div>
    </footer>
  );
};

export default Footer;
